import { updateStudioUrl } from 'lib/studio/navigate'
import { handleHashScroll } from './handleHashScroll'

import {
  NAV_SECTIONS,
  NavItem,
  NavSection,
  PAYMENT_METHODS_ITEM_LABEL,
  SPONSORED_LISTINGS_SECTION_TITLE,
} from './constants'

export const handleStudioLinkClick = (
  event: React.MouseEvent<HTMLAnchorElement>,
  item: NavItem
): void => {
  const isModifiedClick = event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0
  if (!item.href || !item.page || isModifiedClick) {
    return
  }
  event.preventDefault()

  // Scroll to ID Verification div after navigation
  if (item.label === 'ID Verification') {
    setTimeout(() => {
      handleHashScroll('id-verification')
    }, 100)
  }

  const isLeavingOrChangingHash =
    item.href.includes('#') || (typeof window !== 'undefined' && window.location.hash !== '')
  updateStudioUrl({
    page: item.page,
    href: item.href,
    params: { section: item.section, subSection: item.subSection },
    scroll: isLeavingOrChangingHash,
  })
}

// This is going to change after Studio become a single page application
export const buildStudioNavigationLinks = ({
  isArtistOnboarded,
}: {
  isArtistOnboarded: boolean
}): NavSection[] => {
  return NAV_SECTIONS.map((section) => {
    if (section.title !== SPONSORED_LISTINGS_SECTION_TITLE) {
      return section
    }

    return {
      ...section,
      // Payment Methods is only reachable once the artist has finished onboarding.
      items: section.items.map((item) =>
        item.label === PAYMENT_METHODS_ITEM_LABEL
          ? { ...item, isDisabled: !isArtistOnboarded }
          : item
      ),
    }
  })
}
